import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {FormComponent} from './form/form.component';
import {CommonModule} from '@angular/common';
import {OverlayComponent} from './overlay/overlay.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterModule, FormComponent, OverlayComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'mailytica-forms';
}
